export const formatDateToDatetime = (date?: Date): string | undefined => {
  if (!date || isNaN(date.getTime())) return undefined;
  return date.toISOString().substring(0, 10);
};
